import { render, staticRenderFns } from "./YuJiin.vue?vue&type=template&id=68d9aadc&scoped=true"
import script from "./YuJiin.vue?vue&type=script&lang=js"
export * from "./YuJiin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9aadc",
  null
  
)

export default component.exports